export default __webpack_public_path__ + "static/media/318.9558c72b.png";